import normalizeThreadTimestamp from '@/lib/threads/normalizeThreadTimestamp.js';

const getFirstValidThreadTimestamp = (candidates = []) => {
  for (const candidate of candidates || []) {
    const normalized = normalizeThreadTimestamp(candidate);

    if (normalized) {
      return normalized;
    }
  }

  return null;
};

export default getFirstValidThreadTimestamp;
